import { findQueryBuilder } from '@/app/utils/findQueryBuilder';
import Credit from '@spraypaint/Credit';

const findQuery = findQueryBuilder(Credit);
export const buildCreditFindQuery = findQuery.buildQuery;
export const buildCreditFindQueryLoader = findQuery.buildLoader;
export const useCreditFindQuery = findQuery.useFindQuery;
export const buildCreditFindQueryKeyPrefix = findQuery.buildQueryKeyPrefix;
